__turbopack_context__.v({
  "block": "UgmS-q_block",
  "body": "UgmS-q_body",
  "claim": "UgmS-q_claim",
  "close": "UgmS-q_close",
  "closeActions": "UgmS-q_closeActions",
  "cloudContact": "UgmS-q_cloudContact",
  "cloudLink": "UgmS-q_cloudLink",
  "cloudNav": "UgmS-q_cloudNav",
  "cloudNavList": "UgmS-q_cloudNavList",
  "cloudWide": "UgmS-q_cloudWide",
  "counter": "UgmS-q_counter",
  "cta": "UgmS-q_cta",
  "descend": "UgmS-q_descend",
  "figure": "UgmS-q_figure",
  "figureLabel": "UgmS-q_figureLabel",
  "figureValue": "UgmS-q_figureValue",
  "film": "UgmS-q_film",
  "fine": "UgmS-q_fine",
  "h1": "UgmS-q_h1",
  "h2": "UgmS-q_h2",
  "h3": "UgmS-q_h3",
  "hint": "UgmS-q_hint",
  "hintLine": "UgmS-q_hintLine",
  "lead": "UgmS-q_lead",
  "line": "UgmS-q_line",
  "lines": "UgmS-q_lines",
  "mark": "UgmS-q_mark",
  "markCrowd": "UgmS-q_markCrowd",
  "markOurs": "UgmS-q_markOurs",
  "markText": "UgmS-q_markText",
  "media": "UgmS-q_media",
  "next": "UgmS-q_next",
  "object": "UgmS-q_object",
  "objectDetail": "UgmS-q_objectDetail",
  "objectLabel": "UgmS-q_objectLabel",
  "objects": "UgmS-q_objects",
  "of": "UgmS-q_of",
  "open": "UgmS-q_open",
  "outlet": "UgmS-q_outlet",
  "outletDate": "UgmS-q_outletDate",
  "outletName": "UgmS-q_outletName",
  "outlets": "UgmS-q_outlets",
  "primary": "UgmS-q_primary",
  "product": "UgmS-q_product",
  "productHead": "UgmS-q_productHead",
  "products": "UgmS-q_products",
  "punch": "UgmS-q_punch",
  "punchText": "UgmS-q_punchText",
  "second": "UgmS-q_second",
  "sky": "UgmS-q_sky",
  "stage": "UgmS-q_stage",
  "tajy": "UgmS-q_tajy",
  "thinks": "UgmS-q_thinks",
  "verifiedTag": "UgmS-q_verifiedTag",
  "what": "UgmS-q_what",
  "word": "UgmS-q_word",
  "wordAi": "UgmS-q_wordAi",
  "yvyra": "UgmS-q_yvyra",
});
